import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    DialogWrapper: {
        background: "#f5f6fa",
        fontFamily: "'Inter', sans-serif",
        padding: "17px",
        "& .Btn--Primary": {
            background: "#6E7187",
            boxShadow:
                "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            borderRadius: "8px",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "15px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            border: "none",
            padding: "16px",
            display: "block",
            width: "100%",
        },
        "& .BackBtn": {
            border: "none",
            background: "none",
            boxShadow: "none",
            marginRight: "14px",
            cursor: "pointer",
        },
    },
    CustomerDialogActions: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
    },
    Input_text: {
        marginBottom: "24px",
        "& .Input_text__Content": {
            minWidth: "280px",
            width: "150px",
            textAlign: "center",
            "& text": {
                background: "rgba(251, 253, 245, 0.75)",
                borderRadius: "4px",
                width: "100%",
                minWidth: "150px",
                padding: "9px",
                border: "none",
                fontFamily: "'Inter'",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "15px",
                "&::placeholder": {
                    color: "rgba(39, 29, 28, 0.5)",
                },
            },
        },
    },
    List: {
        "& .List_Header": {
            padding: "0 1rem",
            fontWeight: "900",
        },
        "& .List_Items": {
            height: "65vh",
            overflowY: "auto",
            padding: "1rem",
            "& .List__Row": {
                "&:hover": {
                    color: "#FFFFFF",
                    background: "#e14954",
                    cursor: "pointer",
                },
            },
        },
        "& .List__Row": {
            display: "flex",
            color: "#e14954",
            display: "flex",
            padding: "1rem",
            fontSize: "14px",
            background: "#FFFFFF",
            fontStyle: "normal",
            transition: "0.2s all",
            alignItems: "center",
            fontWeight: 600,
            lineHeight: "17px",
            borderRadius: "8px",
            marginBottom: "0.5rem",
        },
        "& .List__Row>div": {
            flex: 1,
        },
        "&.compact": {
            "& .List_Items": {
                height: "35vh",
            },
        },
    },
    AddressDialog: {
        background: "#f5f6fa",
        padding: "17px",
        width: "35vh",
        zIndex: "999",
        "& .Content": {
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            padding: "1rem",
        },
    },
    AddressRow: {
        flex: "1",
        padding: "0.5rem",
        "&>div": {
            flex: 1,
        },
    },
    ActionsFooter: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "auto",
    },
    NewAddressWrapper: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
})); 